import moment from "moment";
import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import ReactTable, { RowInfo } from "react-table";
import { bindActionCreators } from "redux";
import { InlineLoading } from "src/components/common";
import { Link } from "src/components/routing";
import { PAGE_SIZE_OPTIONS } from "src/constants/reactTableConstants";
import { CommitteeMemberRolesBreadcrumbs } from "src/helpers/breadcrumbHelper";
import { findLookupValue } from "src/helpers/lookupHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as CommitteeMemberActions from "../../../actions/committeeMember";
import * as CommitteeMemberRoleActions from "../../../actions/committeeMemberRole";
import * as CommitteeActions from "../../../actions/committees";
import * as NavigationActions from "../../../actions/navigation";
import * as PagingActions from "../../../actions/pages/pagingPage";
import { RestrictedLayout } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { CommitteeMemberSubMenu } from "../../../helpers/subMenuHelper";
import { IFormFilter, ITmdState } from "../../../reducers/index";

import "./CommitteeMemberRolesPage.scss";

interface ICommitteeMemberRolesPageParams {
    committeeId: number;
    committeeMemberId: number;
}

interface ICommitteeMemberRolesPageProps
    extends IRouterProps<ICommitteeMemberRolesPageParams> {
    committeeId: number;
    committeeMemberId: number;

    // From state
    formFilter: IFormFilter;
    committee: Dtos.Committee;
    committeeMember: Dtos.CommitteeMember;
    committeeMemberRoles: Dtos.CommitteeMemberRole[] | undefined;
    lookups: Dtos.Lookup[];

    loadingCommittee: boolean;
    loadCommitteeSuccess: boolean;
    loadCommitteeFailure: boolean;
    loadCommitteeErrorCode: string;

    loadingCommitteeMember: boolean;
    loadCommitteeMemberSuccess: boolean;
    loadCommitteeMemberFailure: boolean;
    loadCommitteeMemberErrorCode: string;

    loadingCommitteeMemberRoles: boolean;
    loadCommitteeMemberRolesSuccess: boolean;
    loadCommitteeMemberRolesFailure: boolean;
    loadCommitteeMemberRolesErrorCode: string;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];

    pageSize: number;
}

interface ICommitteeMemberRolesPageActions extends IRouterActions {
    clearCommitteeMemberRoles: CommitteeMemberRoleActions.ICommitteeMemberRoleClearActionCreator;
    loadCommitteeMemberRoles: CommitteeMemberRoleActions.ICommitteeMemberRoleLoadByCommitteeIdActionCreator;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

    clearCommittee: CommitteeActions.ICommitteeClearActionCreator;
    loadCommittee: CommitteeActions.ICommitteeLoadByIdActionCreator;

    clearCommitteeMember: CommitteeMemberActions.ICommitteeMemberClearActionCreator;
    loadCommitteeMember: CommitteeMemberActions.ICommitteeMemberLoadByIdActionCreator;

}

type CommitteeMemberRolesPageProps = ICommitteeMemberRolesPageProps &
    ICommitteeMemberRolesPageActions;

class CommitteeMemberRolesPage extends React.PureComponent<
    CommitteeMemberRolesPageProps,
    any
> {
    constructor(props: CommitteeMemberRolesPageProps) {
        super(props);
        this.clearCommittee = this.clearCommittee.bind(this);
        this.toggleExportMenu = this.toggleExportMenu.bind(this);

        this.state = {
            exportToggle: false,
            initalised: false,
        };
    }

    componentDidMount() {
        const {
            committeeId,
            committeeMemberId,
            setBreadcrumbs,
            loadCommittee,
            loadCommitteeMember
        } = this.props;
        

        if (committeeId) {
            loadCommittee(committeeId);
        }
        if (committeeMemberId) {
            loadCommitteeMember(committeeMemberId);
        }
        if (committeeId && committeeMemberId) {
            setBreadcrumbs(
                CommitteeMemberRolesBreadcrumbs(committeeId, committeeMemberId)
            );
        }
    }

    componentDidUpdate(prevProps: CommitteeMemberRolesPageProps, _prevState) {
        const { initalised } = this.state;
        const {
            committee,
            committeeId,
            committeeMember,
            loadCommittee,
            setDrawerItems,
            setBreadcrumbs,
            permissions,
            committeeMemberId,
            loadCommitteeMember,
            loadCommitteeMemberRoles,
            lookups,
            loadCommitteeFailure,
            loadCommitteeMemberFailure,
            loadCommitteeMemberRolesFailure,
            loadCommitteeErrorCode,
            loadCommitteeMemberErrorCode,
            loadCommitteeMemberRolesErrorCode,
            navigate,
        } = this.props;

        if (loadCommitteeFailure) {
            navigate(`/error/${loadCommitteeErrorCode}`);
        }
        if (loadCommitteeMemberFailure) {
            navigate(`/error/${loadCommitteeMemberErrorCode}`);
        }
        if (loadCommitteeMemberRolesFailure) {
            navigate(`/error/${loadCommitteeMemberRolesErrorCode}`);
        }

        if (committeeMember) {
            setDrawerItems(
                CommitteeMemberSubMenu(committeeId, committeeMemberId, permissions)
            );
        }

        if (committeeId && committeeMemberId && committee && committeeMember) {
            setBreadcrumbs(
                CommitteeMemberRolesBreadcrumbs(
                    committeeId,
                    committeeMemberId,
                    committee?.name,
                    `${
                        findLookupValue(
                            "Personnel",
                            "SalutationId",
                            committeeMember?.personnel?.salutationId,
                            lookups
                        ) ?? ""
                    } ${committeeMember?.personnel?.displayWithSalutation}`
                )
            );
            if (!initalised) {
                loadCommitteeMemberRoles(
                    committeeId,
                    committeeMember.personnelId
                );
                this.setState({ initalised: true });
            }
        }

        if (committeeId && prevProps.committeeId != committeeId) {
            loadCommittee(committeeId);
        }

        if (
            committeeMemberId &&
            prevProps.committeeMemberId != committeeMemberId
        ) {
            loadCommitteeMember(committeeMemberId);
        }
    }

    componentWillUnmount() {
        this.clearCommittee();
    }

    clearCommittee() {
        this.props.clearCommittee();
        this.props.clearCommitteeMember();
        this.props.clearCommitteeMemberRoles();
    }

    toggleExportMenu() {
        this.setState({
            exportToggle: !this.state.exportToggle,
        });
    }

    showCommitteeMemberRoles(): boolean {
        const { loadingCommitteeMemberRoles, loadCommitteeMemberRolesSuccess } =
            this.props;

        if (!loadingCommitteeMemberRoles && loadCommitteeMemberRolesSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingCommittee,
            loadingCommitteeMember,
            loadingCommitteeMemberRoles,
        } = this.props;

        return (
            <RestrictedLayout
                permission={Dtos.Permission.CommitteeMemberRoleView}
                loading={
                    loadingCommittee ||
                    loadingCommitteeMember ||
                    loadingCommitteeMemberRoles
                }
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const { permissions, committeeId, committeeMemberId } = this.props;

        const canCreate = AuthenticationHelper.hasPermission(
            permissions,
            Dtos.Permission.CommitteeMemberRoleCreate
        );

        return (
            <div>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Roles</h1>
                    </div>
                    <div className="col" style={{ textAlign: "right" }}>
                        {canCreate && (
                            <>
                                <Link
                                    className={"btn btn-primary"}
                                    url={`/committees/${committeeId}/members/${committeeMemberId}/roles/create`}
                                >
                                    Add
                                </Link>
                            </>
                        )}
                    </div>
                </div>
                {!this.showCommitteeMemberRoles() ? (
                    <InlineLoading absoluteCenter={true} size={50} />
                ) : null}
                {this.showCommitteeMemberRoles() ? (
                    <div className="card">
                        <div className="patient-tables">
                            {this.createTable()}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    createTable() {
        const {
            committeeId,
            committeeMemberId,
            committeeMemberRoles,
            pageSize,
            setPageSize,
            lookups,
        } = this.props;

        if (!committeeMemberRoles || committeeMemberRoles.length == 0) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>There are currently no roles to view.</span>
                    </div>
                </div>
            );
        }

        const showPagination = committeeMemberRoles.length > pageSize;

        return (
            <div className="table-wrapper">
                <ReactTable
                    data={committeeMemberRoles}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    defaultPageSize={
                        showPagination ? pageSize : committeeMemberRoles.length
                    }
                    pageSize={
                        showPagination ? pageSize : committeeMemberRoles.length
                    }
                    showPagination={showPagination}
                    className="-striped -highlight -clickable"
                    noDataText="There are currently no roles to display"
                    resizable={false}
                    onPageSizeChange={(val) => setPageSize(val)}
                    getTdProps={(
                        state,
                        rowInfo: RowInfo,
                        _column,
                        _instance
                    ) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                const url = `/committees/${committeeId}/members/${committeeMemberId}/roles/${rowInfo.original.id}/details`;
                                this.props.navigate(url);

                                if (handleOriginal) {
                                    handleOriginal();
                                }
                            },
                        };
                    }}
                    defaultSorted={[
                        {
                            id: "dateStarted",
                            desc: false,
                        },
                    ]}
                    columns={[
                        {
                            id: "id",
                            Header: " ",
                            accessor: "id",
                            maxWidth: 50,
                            Cell: (_props) => (
                                <FontAwesomeIcon
                                    size="lg"
                                    icon={FontAwesomeIcons.Duotone.USERSHIELD}
                                    fixedWidth
                                />
                            ),
                        },
                        {
                            id: "committeeMemberRoleTypeId",
                            Header: "Position",
                            accessor: "committeeMemberRoleTypeId",
                            Cell: (props) => (
                                <span>
                                    {findLookupValue(
                                        "CommitteeMemberRole",
                                        "committeeMemberRoleTypeId",
                                        props.value,
                                        lookups
                                    )}
                                </span>
                            ),
                        },
                        {
                            id: "dateStarted",
                            Header: "Started",
                            accessor: "dateStarted",
                            Cell: (props) => (
                                <span>
                                    {props.value
                                        ? moment(
                                            props.value,
                                            "YYYY-MM-DD HH:mm:ss.SSSSSSS Z"
                                        ).format("DD/MM/YYYY")
                                        : ""}
                                </span>
                            ),
                        },
                        {
                            id: "dateCeased",
                            Header: "Ceased",
                            accessor: "dateCeased",
                            Cell: (props) => (
                                <span>
                                    {props.value
                                        ? moment(
                                            props.value,
                                            "YYYY-MM-DD HH:mm:ss.SSSSSSS Z"
                                        ).format("DD/MM/YYYY")
                                        : ""}
                                </span>
                            ),
                        },
                    ]}
                />
            </div>
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: CommitteeMemberRolesPageProps
): ICommitteeMemberRolesPageProps => {
    let committee: Dtos.Committee | undefined = !(
        state.committees.formData instanceof Array
    )
        ? state.committees.formData
        : undefined;
    let committeeMember: Dtos.CommitteeMember | undefined = !(
        state.committeeMember.formData instanceof Array
    )
        ? state.committeeMember.formData
        : undefined;
    let committeeMemberRoles: Dtos.CommitteeMemberRole[] | undefined =
        state.committeeMemberRole.formData instanceof Array
            ? state.committeeMemberRole.formData
            : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        history: ownProps.history,
        location: ownProps.location,
        match: ownProps.match,

        committeeMemberRoles: committeeMemberRoles,
        formFilter: state.trials.formFilter,
        lookups: state.committeeMemberRole.lookups,

        loadingCommitteeMemberRoles:
            state.committeeMemberRole.loadState &&
            state.committeeMemberRole.loadState.status == RequestState.Pending,
        loadCommitteeMemberRolesSuccess:
            state.committeeMemberRole.loadState &&
            state.committeeMemberRole.loadState.status == RequestState.Success,
        loadCommitteeMemberRolesFailure:
            state.committeeMemberRole.loadState &&
            state.committeeMemberRole.loadState.status == RequestState.Failure,
        loadCommitteeMemberRolesErrorCode:
            state.committeeMemberRole.loadState.errorCode,

        committeeId: ownProps.match.params.committeeId,
        committee: committee!,

        committeeMemberId: ownProps.match.params.committeeMemberId,
        committeeMember: committeeMember!,

        loadingCommittee:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Pending,
        loadCommitteeSuccess:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Success,
        loadCommitteeFailure:
            state.committees.loadState &&
            state.committees.loadState.status == RequestState.Failure,
        loadCommitteeErrorCode: state.committees.loadState.errorCode,

        loadingCommitteeMember:
            state.committeeMember.loadState &&
            state.committeeMember.loadState.status == RequestState.Pending,
        loadCommitteeMemberSuccess:
            state.committeeMember.loadState &&
            state.committeeMember.loadState.status == RequestState.Success,
        loadCommitteeMemberFailure:
            state.committeeMember.loadState &&
            state.committeeMember.loadState.status == RequestState.Failure,
        loadCommitteeMemberErrorCode: state.committeeMember.loadState.errorCode,

        user: state.user.data,
        permissions: permissions,

        pageSize: state.pagingPage.pageSize,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: CommitteeMemberRolesPageProps
): ICommitteeMemberRolesPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadCommitteeMemberRoles: bindActionCreators(
            CommitteeMemberRoleActions.LoadCommitteeMemberRoleByCommitteeId,
            dispatch
        ),
        clearCommitteeMemberRoles: bindActionCreators(
            CommitteeMemberRoleActions.Clear,
            dispatch
        ),

        loadCommittee: bindActionCreators(
            CommitteeActions.LoadCommitteeById,
            dispatch
        ),
        clearCommittee: bindActionCreators(CommitteeActions.Clear, dispatch),

        loadCommitteeMember: bindActionCreators(
            CommitteeMemberActions.LoadCommitteeMemberById,
            dispatch
        ),
        clearCommitteeMember: bindActionCreators(
            CommitteeMemberActions.Clear,
            dispatch
        ),

        setPageSize: bindActionCreators(
            PagingActions.PageSizeChanged,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<
    ICommitteeMemberRolesPageParams,
    CommitteeMemberRolesPageProps
>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        CommitteeMemberRolesPage
    ) as unknown as ComponentType<CommitteeMemberRolesPageProps>
) as ComponentType<any>;
